/* PureChews theme JS — scroll reveal animations (fires early so sections never sit blank) */
(function(){
  'use strict';
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px 20% 0px' });
  els.forEach(function(el){ io.observe(el); });
})();

/* Multi-pouch picker: tapping a pouch option that is already checked still switches the buyer to one-time purchase */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var input = e.target && e.target.closest ? e.target.closest('.pack input, .pc-pack input') : null;
    if (!input || !input.checked) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
